import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  background-color: var(--color-button-accent);
  color: var(--color-container-card-default);
  padding: 5px 25px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid var(--color-button-accent);

  &:hover {
    background-color: var(--color-container-card-default);
    color: var(--color-button-accent);
  }
  ${(props) => props.$fullWidth && `
    width: 100%;
    display: block;
  `}

  @media(max-width: 768px){
  font-size: 12px;
  padding: 4px 16px;
  margin-right: auto;
  
  }
`;

const ContainerButton = ({ buttonText, action, disabled, fullWidth = false, className, style }) => {
  return (
    <StyledButton
      className={className}
      style={style}
      disabled={disabled}
      onClick={action}
      $fullWidth={fullWidth}
    >
      {buttonText}
    </StyledButton>
  );
};

export default ContainerButton;
